<template>
  <div id="content">
    <div class="mission text-center block block-pd-sm block-bg-noise">
      <div class="container">
        <h2 class="text-shadow-white">
          A quality product. When you need it. At a competitive price.
        </h2>
      </div>
    </div>

    <HomePageCapabilityShowcase></HomePageCapabilityShowcase>
    <HomePageServices></HomePageServices>
    <HomePageIso></HomePageIso>
    <HomePageTestimonials></HomePageTestimonials>
  </div>
</template>

<script>
import HomePageCapabilityShowcase from "@/components/HomePageCapabilityShowcase";
import HomePageServices from '@/components/HomePageServices';
import HomePageIso from '@/components/HomePageIso';
import HomePageTestimonials from '@/components/HomePageTestimonials';

export default {
  name: "HomePage",
  components: {
    HomePageCapabilityShowcase,
    HomePageServices,
    HomePageIso,
    HomePageTestimonials
}
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue